import React, { useState, useEffect } from 'react';
import { TYPE_SUCCESS, TYPE_FAIL, INTERVAL } from "assets/constants/Constants";
import { EDIT_ICON, TRASH_ICON, CALENDER_ICON} from "assets/constants/Icons";
import Spinner from 'components/Spinner';
import ShowToast from 'components/ShowToast';
import { hasPermission } from 'components/Permission';
import { getRegionList, createRegion, updateRegion, deleteRegion,createHistoryList } from "lib/axiosUtils";
import { LOG_TEXT, MODULE_NAMES } from 'assets/constants/Constants';
import moment from 'moment';
import { Divider } from '@mui/material';
import { BusinessIcon} from 'assets/constants/Icons';

const RegionTablesPage = (props) => {
    const [isLoading, setIsLoading] = useState(true);
    const [name, setName] = useState("");
    const [regionId, setRegionId] = useState(null);
    const [buttonText, setButtonText] = useState("Add Region");
    const [regionList, setRegionList] = useState([]);
    const [error, setError] = useState({});

    useEffect(() => {
        fetchRegionList();
    }, []);

    const fetchRegionList = async () => {
        setIsLoading(true);
        const response = await getRegionList({}, {});
        setRegionList(response.data.result || []);
        setIsLoading(false);
    };

    const nameChange = (event) => {
        setName(event.target.value);
    };

    const isFormValid = () => {
        let isValid = true;
        let errorData = {};
        if (name.trim() === "") {
            isValid = false;
            errorData.name = "Please add Region name";
        }
        setError(errorData);
        return isValid;
    };

    const isSuccess = (response) => {
        return response && (
            response.status === 200 ||
            response.statusCode === 200 ||
            response.status === 201 ||
            response.statusCode === 201 ||
            response.status === 204 ||
            response.statusCode === 204
        );
    };

    const addNameHandler = async () => {
        if (isFormValid()) {
            setIsLoading(true);
            const requestData = { name };
            let response = null;
            let auditresponse=null;
            let userData = JSON.parse(localStorage.getItem('userData'));
            let userID = userData._id;
            let logText = LOG_TEXT.REGION_ADDED;
            let moduleName = MODULE_NAMES.REGION;

            if (regionId === null) {
                response = await createRegion({}, requestData);
            } else {
                response = await updateRegion({}, requestData, regionId);
            }

            if (isSuccess(response)) {
                await fetchRegionList();
                const tempId = regionId;
                setName("");
                setRegionId(null);
                setButtonText("Add Region");
                setIsLoading(false);
                if (tempId === null) {
                    const regionData = response.data.result;
                    const auditData = {
                        logText,
                        userID,
                        moduleName,
                        doc_id: regionData._id
                    };
                    auditresponse = await createHistoryList({}, auditData);
                    ShowToast('Region created successfully', TYPE_SUCCESS, INTERVAL, props, "");
                } else {
                    ShowToast('Region updated successfully', TYPE_SUCCESS, INTERVAL, props, "");
                }
            } else {
                setIsLoading(false);
                ShowToast('Operation failed', TYPE_FAIL, INTERVAL, props, "");
            }
        }
    };

    const handleEdit = (item) => {
        setRegionId(item._id);
        setName(item.name);
        setButtonText("Update Region");
    };

    const handleDelete = async (item) => {
        if (window.confirm("Are you sure you want to delete this Region?")) {
            setIsLoading(true);
            const response = await deleteRegion({}, {}, item._id);
            if (isSuccess(response)) {
                await fetchRegionList();
                setName("");
                setRegionId(null);
                setButtonText("Add Region");
                setIsLoading(false);
                ShowToast('Region deleted successfully', TYPE_SUCCESS, INTERVAL, props, "");
            } else {
                setIsLoading(false);
                ShowToast('Something went wrong. Please try again.', TYPE_FAIL, INTERVAL, props, "");
            }
        }
    };

    return (
        <div className="main-content">
            <div className="pagetitle row" style={{ color: 'black', paddingTop: 15, marginTop: "-25px" }}>
                <div className="col-md-10 sm_device">
                    <BusinessIcon aria-hidden="true" />
                    <span style={{ marginLeft: '7px' }}>Region</span>
                </div>
                <div className="col-md-2 sm_device" style={{ textAlign: 'right' }}>
                    <i className={`${CALENDER_ICON}`}></i> {moment().format('DD MMM YYYY')}
                </div>
            </div>
            <Divider sx={{ mb: 2, mt: 2 }} />
            <div className="back">
                <ul className="breadcrumb1">
                    <li>Region</li>
                </ul>
            </div>
            <div className="role-wrapper">
                <div className="input-div">
                    <div>
                        <input
                            className="form-control brand-font placeholderColor add-role-input"
                            style={{ padding: "2rem", fontSize: "1.3rem" }}
                            value={name}
                            onChange={nameChange}
                            placeholder="Enter Region name"
                        />
                        <div className="text-danger error-msg">
                            {error.name}
                        </div>
                    </div>
                    <div>&nbsp;</div>
                    {
                        hasPermission('region', 'create') && (
                            <button className="brand-button ml-5 role-button" onClick={addNameHandler}>
                                {buttonText}
                            </button>
                        )
                    }
                </div>

                {isLoading ? (
                    <Spinner />
                ) : (
                    <div className="mt-5 mb-5 border user-table-div">
                        {regionList.length > 0 ? (
                            <table className="table list-table role-table">
                                <thead>
                                    <tr>
                                        <th className="pl1">Region</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody className="role-list-table">
                                    {regionList.map((item) => (
                                        <tr key={item._id}>
                                            <td className="role-td pl1">{item.name}</td>
                                            <td className="action-td center">
                                                <div className="action-div">
                                                    {
                                                        hasPermission('region', 'update') &&(
                                                            <span onClick={() => handleEdit(item)}>
                                                                <i className={EDIT_ICON} title="Edit Region"></i>
                                                            </span>
                                                        )
                                                    }
                                                    {
                                                       hasPermission('region', 'delete') &&(
                                                        <span onClick={() => handleDelete(item)}>
                                                            <i className={TRASH_ICON} title="Delete Region"></i>
                                                        </span>
                                                       ) 
                                                    }
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        ) : (
                            <div className="text-center pt-2">
                                <label>No Regions found!</label>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default RegionTablesPage;
